import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/ttiTestingLaboratories"

const TtiTestingLaboratories = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default TtiTestingLaboratories

export const query = graphql`
  query TtiTestingLaboratoriesCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/ttiTestingLaboratories-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
